/* eslint-disable prefer-const */
import { PayloadAction } from "@reduxjs/toolkit";
import { closeAppBackdrop, notify, showAppBackdrop } from "features/app/store/slice";
import { call, put, takeEvery } from "redux-saga/effects";
import { IApiResponse } from "types/api";
import { formatPath, getQueryString } from "utils";
import { apiDelete, apiGet } from "utils/api";
import HistoryManagementPaths from "../models/paths";
import { deleteHistory, deleteHistorySuccess, fetchHistorys, fetchHistorysSuccess } from "./slice";

const apiFetchHistorys = async (filter: any) => {
  const queryString = getQueryString({ ...filter });
  return apiGet<any>(
    formatPath(HistoryManagementPaths.get_historys, queryString), 
  );
};

function* handleFetchHistorys(action: PayloadAction<any>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiFetchHistorys, action.payload);
    if(response.data){
      yield put(fetchHistorysSuccess(response.data.history_user));
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

const apiDeleteHistory = async (history_id: any) => {
  return apiDelete<any>(
    formatPath(HistoryManagementPaths.delete_history),
    {
      history_id
    }
  );
};

function* handleDeleteHistory(action: PayloadAction<any>) {
  try {
    yield put(showAppBackdrop());
    const response: IApiResponse<any> = yield call(apiDeleteHistory, action.payload);
    if(response.data){
      yield put(deleteHistorySuccess(response.data.history_user));
      yield put(
        notify(`Delete history success`, {
          options: { variant: 'success' },
        })
      );
      yield put(closeAppBackdrop());
    } else {
      if (response.detail !== '') {
        yield put(
          notify(`${response.detail}`, {
            options: { variant: 'error' },
          })
        );
      }
      yield put(closeAppBackdrop());
    }
  } catch (e) {
    yield put(closeAppBackdrop());
  }
}

export default function* HistoryManagementSaga() {
  yield takeEvery(fetchHistorys.type, handleFetchHistorys);
  yield takeEvery(deleteHistory.type, handleDeleteHistory);
}
